import React, { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";
import {
  getDirectusField,
  getItemsFromCollection,
} from "directus/src/operations";

import { fetchCurrencies } from "components/currency/api";
import { useQuery } from "@tanstack/react-query";

const CurrencyInput = ({ value, onChange, disabled }) => {
  const [selectedCurrency, setSelectedCurrency] = useState("");
  useEffect(() => {
    if (value) {
      setSelectedCurrency(value);
    }
  }, [value]);
  const { data, isLoading, error } = useQuery({
    queryKey: ["currencies"],
    queryFn: async () => {
      const currencies = await fetchCurrencies();

      const data = currencies.map((currency) => {
        return { name: currency.name, id: currency.id };
      });
      return data;
    },
  });

  function handleChange(value) {
    setSelectedCurrency(value);
    onChange?.(value);
  }

  if (error) {
    return "Error in Currency Fetching";
  }

  return (
    <Select
      onValueChange={handleChange}
      value={selectedCurrency}
      disabled={disabled}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select" />
      </SelectTrigger>
      <SelectContent>
        {data &&
          data.map((level) => (
            <SelectItem key={level.id} value={level.id}>
              {level.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencyInput;
